import {Button, Flex, Text, VStack} from "@chakra-ui/react";
import { useMemo } from "react";

const SummaryTickets = ({attendees, ticketTypes, cart, isFree, dwn, order, t}) => {
    const label = t('ticket.standard');

    const ticketsToShow = useMemo(() => {
        // Jeśli mamy gotowe zamówienie (krok potwierdzenia), używamy danych z serwera
        if (order?.tickets) {
            return order.tickets.map(ticket => ({
                ticketId: ticket.ticketId,
                downloadToken: ticket.downloadToken,
                name: ticketTypes?.find(tt => String(tt.id) === String(ticket.ticketId))?.name || ticket.name || label,
                attendee: {
                    firstName: ticket.firstName || ticket.name,
                    lastName: ticket.lastName || ticket.surName
                }
            }));
        }

        // Krok podsumowania - symulujemy listę biletów na podstawie koszyka i danych uczestników
        if (isFree) {
            const qty = Math.max(0, Number(cart?.quantity ?? 0));
            return Array.from({ length: qty }, (_, i) => ({
                ticketId: null,
                name: label,
                attendee: attendees?.[i]
            }));
        }

        const list = [];
        let attendeeIndex = 0;
        
        const personalizedIds = new Set(
            ticketTypes?.filter(tt => tt.isPersonalized).map(tt => String(tt.id)) || []
        );

        Object.entries(cart?.quantities || {}).forEach(([ticketId, qty]) => {
            const tt = ticketTypes?.find(x => String(x.id) === String(ticketId));
            const ticketName = tt?.name || label;
            const isPersonalized = personalizedIds.has(String(ticketId));

            for (let i = 0; i < qty; i++) {
                list.push({
                    ticketId,
                    name: ticketName,
                    attendee: isPersonalized ? attendees?.[attendeeIndex++] : null
                });
            }
        });
        return list;
    }, [order, isFree, cart, ticketTypes, attendees, label]);

    return <VStack spacing={4} align="stretch">
        {ticketsToShow.map((ticket, i) => (
            <Flex key={i} p={4} borderWidth={0} bgColor={'#F8F5F4'} gap="32px" flexDirection={"row"}
                  fontFamily="body" fontSize="18px" fontWeight="500" alignItems={"center"}>
                <Text fontFamily="body" fontSize="20px" fontWeight="700" color={'#7A1F35'}>
                    #{i+1}
                </Text>
                <Flex w={"full"} gap="32px">
                    <Flex flexDirection={"column"} flex="1">
                        <Text>
                            {t('order.summary.ticket.type')}
                        </Text>
                        <Text fontWeight="700">
                            {ticket.name}
                        </Text>
                    </Flex>
                    {ticket.attendee && (
                        <Flex flexDirection={"column"} flex="1">
                            <Text>
                                {t('order.summary.ticket.name')}
                            </Text>
                            <Text fontWeight="700">
                                {ticket.attendee.firstName} {ticket.attendee.lastName}
                            </Text>
                        </Flex>
                    )}
                </Flex>
                {dwn && ticket.downloadToken && <Flex w={"full"} justifyContent={"flex-end"}>
                    <Button
                    borderRadius={'12px'}
                    color={'#FFFFFF'}
                    bgColor={'#7A1F35'}
                    py={'25px'}
                    px={'45px'}
                    onClick={() => dwn(ticket.ticketId, ticket.downloadToken)}>
                        {t('order.summary.ticket.download')}
                </Button>
                </Flex>}
            </Flex>
        ))}
    </VStack>;
}

export default SummaryTickets;
